/* global Swiper */

// :not excludes swiper awards and swiper clients
const containers = document.querySelectorAll('.swiper-container:not([class*="swiper-container-id"])');

containers.forEach(container => {
  const swiperControls = container.querySelector('.swiper-controls');

  const id = container.dataset.id;

  const swiper = new Swiper(`.swiper-container-${id}`, {
    grabCursor: true,
    autoHeight: true,
    pagination: '.swiper-pagination',
    paginationType: 'fraction',
    nextButton: '.swiper-button-next',
    prevButton: '.swiper-button-prev',
  });

  const setFigCaption = function () {
    const currentSlide = swiper.slides[swiper.activeIndex];
    const figCaption = currentSlide.querySelector('.swiper-figcaption');
    swiperControls.style.top = `${-figCaption.clientHeight}px`;
  };

  window.addEventListener('load', setFigCaption);
  swiper.on('slideChangeStart', setFigCaption);
});



// WEBPACK FOOTER //
// ./scripts/swiper.js